import { render, staticRenderFns } from "./DeptList.vue?vue&type=template&id=5e7a7a36&scoped=true&"
import script from "./DeptList.vue?vue&type=script&lang=js&"
export * from "./DeptList.vue?vue&type=script&lang=js&"
import style0 from "./DeptList.vue?vue&type=style&index=0&id=5e7a7a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a7a36",
  null
  
)

export default component.exports